module.exports = __webpack_public_path__ + "img/_54A6775.d4ab0a02.jpg";